import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ops, asList, fmtDate, OPS } from "@/admin/api";
import { PageTitle, EmptyState, Pill, ActionButton, Table, cell } from "@/admin/ui";

export default function Clubs() {
  const [clubs, setClubs] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    ops(OPS.clubs).then((d) => setClubs(asList(d, "clubs"))).catch((e) => setError(e.message));
  }, []);

  const remove = async (id, name) => {
    try {
      await ops(OPS.removeClub(id), { method: "DELETE" });
      setClubs((c) => c.filter((x) => x.id !== id));
      toast.success(`Removed ${name}`);
    } catch (e) {
      toast.error(`Remove failed: ${e.message}`);
    }
  };

  return (
    <div data-testid="admin-clubs-page">
      <PageTitle eyebrow="Admin Portal" title="Club Management" />
      {error ? (
        <EmptyState title="Club list unavailable" hint={error} />
      ) : !clubs ? (
        <p className="label-tech text-neutral-500">Loading…</p>
      ) : !clubs.length ? (
        <EmptyState title="No clubs yet" />
      ) : (
        <Table head={["Club", "Category", "Area", "Members", "Created", "Status", ""]} testId="clubs-table">
          {clubs.map((c) => (
            <tr key={c.id} data-testid={`club-row-${c.id}`}>
              <td className={cell}>
                <p className="font-semibold text-white">{c.name}</p>
                <p className="max-w-xs truncate text-xs text-neutral-500">{c.description}</p>
              </td>
              <td className={cell}>{c.category || "—"}</td>
              <td className={cell}>{c.area || "—"}</td>
              <td className={cell}>
                {c.memberCount ?? 0} <span className="text-neutral-500">· {c.followerCount ?? 0} followers</span>
              </td>
              <td className={cell}>{fmtDate(c.createdAt)}</td>
              <td className={cell}>
                <Pill tone={c.status === "approved" ? "green" : "amber"}>{c.status || "—"}</Pill>
                {c.verified && <Pill tone="cyan">Verified</Pill>}
              </td>
              <td className={`${cell} text-right`}>
                <ActionButton tone="red" onClick={() => remove(c.id, c.name)} data-testid={`club-remove-${c.id}`}>Remove</ActionButton>
              </td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
